import { useState, useEffect } from "react";
import Axios from "axios";
import { useLocation, Link} from 'react-router-dom';


import "./Homepage.scss"

import Datatable from "../../component/datatable/Datatable";
import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import CreateClientWizard from "../../component/createClientWizard/CreateClientWizard";


import { AlertTriangle, Check, Loader2, RefreshCw } from 'lucide-react';






export default function HomepageCons() {


  const location = useLocation(); // Get the current location (URL)

  const userId = location.pathname.split('/')[2]

  const [completeNumber, setCompleteNumber] = React.useState();
  const [lateNumber, setLateNumber] = React.useState();
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [isRefreshingDemo, setIsRefreshingDemo] = useState(false);

 

  

    const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS

    const [data, setData] = useState(null);

   
  

useEffect(() => {
    Axios ({
       method: "GET",
      withCredentials: true,
        url: `${backEndUrl}/auth/consultantLog`,
 
     
      }).then((res) => {
       setData(res.data);       
       setCompleteNumber((res.data.clients.filter(c => c.fileStatus === 'complete' && c.archive === false)).length)
       setLateNumber((res.data.clients.filter(c => c.fileStatus === 'late' && c.archive === false)).length)
      });
      }, []) 

 
// In HomepageCons.js

// 1. Add this Helper Function inside your component to handle the logic
const handleClientEvent = (event) => {
  const { type, client, tempId } = event.detail;

  if (type === 'ADD') {
      setData((prev) => ({
          ...prev,
          clients: [client, ...prev.clients]
      }));
  } 
  else if (type === 'UPDATE_REAL_ID') {
      setData((prev) => {
          // Remove the temp one and insert the real one
          const otherClients = prev.clients.filter(c => c._id !== tempId);
          return {
              ...prev,
              clients: [client, ...otherClients]
          };
      });
      // Optional: Trigger a background refresh to ensure stats are 100% synced
      refreshList(); 
  }
  else if (type === 'REFRESH_ALL') {
      refreshList();
  }
};

// 2. Add this useEffect to attach the listener
useEffect(() => {
  window.addEventListener('CLIENT_ACTION', handleClientEvent);

  // Cleanup listener when leaving page
  return () => {
      window.removeEventListener('CLIENT_ACTION', handleClientEvent);
  };
}, []); // Empty array = run once on mount


const refreshList = () => {
  Axios({
    method: "GET",
    withCredentials: true,
    url: `${backEndUrl}/auth/consultantLog`, // Same URL as your useEffect
  }).then((res) => {
     setData(res.data); // <--- THIS replaces the 'temp_' row with the real DB row
     
     // Optional: Update stats
     setCompleteNumber((res.data.clients.filter(c => c.fileStatus === 'complete' && c.archive === false)).length);
     setLateNumber((res.data.clients.filter(c => c.fileStatus === 'late' && c.archive === false)).length);
  }).catch((err) => {
     console.error("Failed to refresh list", err);
  });
};


const handleNewClientAdded = (newClientData) => {
  // 1. IMMEDIATELY add the client to the datatable for instant feedback
  setData((prevData) => {
    if (!prevData) return prevData;
    
    // Ensure the new client appears at the top of the list
    const updatedClients = [newClientData, ...prevData.clients];
    
    return {
      ...prevData,
      clients: updatedClients
    };
  });
  
  // 2. Close the wizard immediately so the user can see the client appear in the datatable
  // This provides instant feedback - the client will be visible right away


  // 3. Check if we have a real ID or temp ID
  const isTempId = newClientData._id && newClientData._id.toString().startsWith('temp_');
  
  if (isTempId) {
    // If temp ID, poll until we get the real client and replace the temp one
    let attempts = 0;
    const maxAttempts = 10; // Try for up to 10 seconds (10 * 1000ms)
    
    const pollForRealClient = () => {
      attempts++;
      
      Axios({
        method: "GET",
        withCredentials: true,
        url: `${backEndUrl}/auth/consultantLog`,
      }).then((res) => {
        const updatedData = res.data;
        const realClient = updatedData.clients.find(c => 
          c.client_Email === newClientData.client_Email && 
          c.client_firstName === newClientData.client_firstName &&
          c.client_lastName === newClientData.client_lastName &&
          c._id && !c._id.toString().startsWith('temp_')
        );
        
        // If we found the client with a real ID, replace the temp one in state
        if (realClient && realClient._id && !realClient._id.toString().startsWith('temp_')) {
          setData((prevData) => {
            if (!prevData) return prevData;
            const updatedClients = [newClientData, ...prevData.clients];
            return {
                ...prevData,
                clients: updatedClients
            };
        });
          
          setCompleteNumber((updatedData.clients.filter(c => c.fileStatus === 'complete' && c.archive === false)).length);
          setLateNumber((updatedData.clients.filter(c => c.fileStatus === 'late' && c.archive === false)).length);
        } else if (attempts < maxAttempts) {
          // Keep polling if we haven't found it yet
          setTimeout(pollForRealClient, 1000);
        } else {
          // Fallback: refresh the entire list after max attempts
          console.warn("⚠️ Max polling attempts reached, refreshing list");
          refreshList();
        }
      }).catch((err) => {
        console.error("Failed to poll for client", err);
        if (attempts < maxAttempts) {
          setTimeout(pollForRealClient, 1000);
        } else {
          refreshList();
        }
      });
    };
    
    // Start polling after a short delay to allow the UI to update first
    setTimeout(pollForRealClient, 1000);
  } else {
    // If we already have a real ID, just refresh to update stats after a brief delay
    setTimeout(() => {
      refreshList();
    }, 500);
  }
};


const handleRefreshDemoClients = async () => {
  setIsRefreshingDemo(true);
  try {
    await Axios.put(`${backEndUrl}/updateClient/refreshDemoClients`, {}, { withCredentials: true });
    refreshList();
  } catch (err) {
    console.error('Failed to refresh demo clients', err);
  } finally {
    setIsRefreshingDemo(false);
  }
};

if (data === undefined || !data) {

    return (
<div style={{marginTop:'20%', marginLeft:'50%' }}>  
      <CircularProgress color="secondary" />
      </div>      
      )

}


else {




    const activeClients = data?.clients?.filter((client) => client.archive === false && client.fileStatus === 'uncomplete')?.length || 0;
    const overviewCards = [
      {
        id: 'collecting',
        title: 'In Progress',
        value: activeClients,
        description: 'Active clients currently collecting docs',
        icon: Loader2,
        iconColor: 'text-blue-600',
        iconBg: 'bg-blue-50',
        badge: 'Active portals',
        link: `/dashboard/collecting`,
        cta: 'Open client list',
      },
      {
        id: 'completed',
        title: 'Ready to review',
        value: completeNumber ?? 0,
        description: 'Files with 100% documents collected',
        icon: Check,
        iconColor: 'text-green-600',
        iconBg: 'bg-green-50',
        badge: 'Completed',
        link: `/dashboard/completed`,
        cta: 'View completed files',
      },
      {
        id: 'late',
        title: 'Deadline Missed',
        value: lateNumber ?? 0,
        description: 'Files that have passed their deadline and are still missing documents',
        icon: AlertTriangle,
        iconColor: 'text-red-600',
        iconBg: 'bg-red-50',
        badge: 'Late files',
        link: `/dashboard/late`,
        cta: 'Review late files',
      },
    ];

    return(

    
   
    
      


   
        
       
      <div className="listContainer">

      <div>
   

    
      

    
<div>
{/*       <h3 className="text-base font-semibold text-gray-900">Overview</h3>

      <button 
  className="link" 
  id="new-client" 
  onClick={() => setIsWizardOpen(true)}
>
  Create a new client
</button> */}

      {/* ── TEMP: refresh demo clients ── */}
      {/* <div className="mb-4 flex justify-end">
        <button
          onClick={handleRefreshDemoClients}
          disabled={isRefreshingDemo}
          className="flex items-center gap-2 px-4 py-2 rounded-xl bg-amber-50 border border-amber-200 text-amber-700 text-sm font-semibold hover:bg-amber-100 transition-all disabled:opacity-50"
        >
          <RefreshCw className={`h-4 w-4 ${isRefreshingDemo ? 'animate-spin' : ''}`} />
          {isRefreshingDemo ? 'Refreshing…' : 'Refresh Demo Clients'}
        </button>
      </div> */}

      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {overviewCards.map((card) => (
          <div
            key={card.id}
            className="group relative flex min-h-[180px] flex-col rounded-2xl border-2 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg"
          >
            <div className="mb-3 flex items-center gap-3">
              <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${card.iconBg}`}>
                <card.icon className={`h-5 w-5 ${card.iconColor}`} strokeWidth={card.strokeWidth || 2.5} />
              </div>
              <div className="flex flex-col">
                <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
                  {card.title}
                </span>
                <span className="text-[11px] font-medium text-slate-400">{card.badge}</span>
              </div>
            </div>

            <div className="mt-auto">
              <span className="mb-1 block text-3xl font-bold text-slate-900">{card.value ?? 0}</span>
              <p className="text-xs font-medium text-slate-600">{card.description}</p>
            </div>

            {card.link && (
              <div className="mt-3 border-t border-gray-100 pt-3">
                <Link
                  to={card.link}
                  className="inline-flex items-center gap-2 text-sm font-semibold text-indigo-600 transition hover:text-indigo-500"
                >
                  {card.cta}
                  <span aria-hidden="true">→</span>
                </Link>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
   


   
        <Datatable 
              clients={data.clients}
              rid={data.id}
              consultantStorage={data.storageUsed}
              getRowId={(row) => row.data.clients._id}
              getRowClient={(row) => row.data.clients}

           
        />
  
  
        


        <div> 
     

      
      

      
     



   

        </div>

 </div>

 <CreateClientWizard 
        isOpen={isWizardOpen} 
        onClose={() => setIsWizardOpen(false)}
        data={data}
        availableTemplates={data?.docTemplates || []}
        onCreateClient={handleNewClientAdded}
      />
 </div>
 
    ) 
}
  
}